import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShare, FaDownload } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useGallery } from '../context/GalleryContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Photo.css';

const Photo = ({
  id,
  urls: { regular, small },
  alt_description,
  likes,
  user: {
    name,
    portfolio_url,
    profile_image: { medium },
  },
  width,
  height,
}: {
  id: string;
  urls: { regular: string; small: string };
  alt_description: string | null;
  likes: number;
  user: { name: string; portfolio_url: string | null; profile_image: { medium: string } };
  width?: number; // Optional
  height?: number; // Optional
}) => {
  const [showActions, setShowActions] = useState(false);
  const { toggleFavorite, favorites } = useGallery();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const isFavorite = favorites.some(fav => fav.id === id);

  const handleFavorite = (e: any) => {
    e.preventDefault();
    if (!currentUser) {
      if (window.confirm("Please login to save favorites!")) {
        navigate('/login');
      }
      return;
    }
    toggleFavorite({ id, urls: { regular, small }, alt_description, likes, user: { name, portfolio_url, profile_image: { medium } }, width, height });
  };

  const handleDownload = (e: any) => {
    e.preventDefault();
    window.open(regular, '_blank');
  };

  const handleShare = (e: any) => {
    e.preventDefault();
    if (navigator.share) {
      navigator.share({
        title: alt_description || 'Artwork',
        url: regular,
      });
    } else {
      navigator.clipboard.writeText(regular);
      alert('Link copied to clipboard!');
    }
  };

  const getAspectRatio = () => {
    if (width && height) {
      return width / height;
    }
    return 1;
  };

  return (
    <motion.div
      className="photo-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
      style={{
        aspectRatio: getAspectRatio()
      }}
    >
      <Link to={`/photo/${id}`} className="photo-link">
        <div className="photo-wrapper">
          <img
            src={regular}
            alt={alt_description || 'Artwork'}
            className="photo-image"
            loading="lazy"
          />

          <div className={`photo-overlay ${showActions ? 'show' : ''}`}>
            <div className="photo-header">
              <div className="user-info">
                <div className="user-avatar-small">
                  <img src={medium} alt={name} />
                </div>
                <span className="user-name">{name}</span>
              </div>
            </div>

            <div className="photo-actions">
              <button
                className={`action-btn ${isFavorite ? 'favorite' : ''}`}
                onClick={handleFavorite}
                title="Favorite"
              >
                <FaHeart />
              </button>
              <button className="action-btn" onClick={handleShare} title="Share">
                <FaShare />
              </button>
              <button className="action-btn" onClick={handleDownload} title="Download">
                <FaDownload />
              </button>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default Photo; 